import * as React from "react";

const TelegramSVG = () => (
  <svg
    viewBox="0 0 100 100" // Ensure this defines the full content area
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    preserveAspectRatio="xMinYMid meet" // Ensures alignment to the left
  >
    <g transform="translate(-10, -20)"> {/* Move left by -10 units */}
      <path
        d="M29,63.5C47.7,55.3,60.2,50,66.5,47.4C84.3,40,88,38.7,90.4,38.6c0.5,0,1.7,0.1,2.5,0.7
        c0.6,0.5,0.8,1.2,0.9,1.7s0.2,1.6,0.1,2.5c-1,10.1-5.1,34.8-7.3,46.1c-0.9,4.8-2.7,6.4-4.4,6.6c-3.7,0.3-6.6-2.5-10.2-4.8
        c-5.6-3.7-8.8-6-14.3-9.6c-6.3-4.2-2.2-6.5,1.4-10.2c0.9-1,17.4-15.9,17.7-17.3c0-0.2,0.1-0.8-0.3-1.1c-0.4-0.3-0.9-0.2-1.3-0.1
        c-0.6,0.1-9.6,6.1-27.1,17.9c-2.6,1.8-4.9,2.6-7,2.6c-2.3,0-6.7-1.3-10-2.4c-4-1.3-7.2-2-6.9-4.2C24.4,65.9,26,64.7,29,63.5z"
        fill="white"
        fillOpacity={0.17}
      />
    </g>
  </svg>
);

export default TelegramSVG;
